import { errors } from "@ryde/shared";

import { LOGIN_REDIRECT_ERROR_KEYS } from "./login.page.constants";

/** `?error=` comes from the URL, so anything but a key the backend redirects with shows the generic error. */
export const getLoginRedirectErrorKey = (error: string): string =>
  LOGIN_REDIRECT_ERROR_KEYS.includes(error)
    ? error
    : errors.common.authenticationError;
